/** @type {import("@mui/material").SxProps<Theme>} */
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const styles = (theme, image, linkFontColor) => ({
  title: {
    color: theme.palette.primary.textColor3,
  },
  addon_cards_withImg: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    position: 'relative',
    background: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${image})center no-repeat`,
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  addon_cards: {
    borderRadius: '10px',
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    position: 'relative',
    // background: `no-repeat center url(${image})`,
    // backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      boxShadow: 'none',
      background: 'transparent',
    },
  },
  infoCard: {
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow2Dark}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow2Medium}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow2Lite}`,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      maxHeight: '6.5rem',
    },
    padding: '0.5rem',
    maxHeight: '5.25rem',
  },
  addonCard_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: 2,
    paddingRight: 2,
    '& a': {
      color: linkFontColor,
    },
  },
  checkOffersButton: {
    backgroundColor: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,

    height: '2.5rem',

    marginLeft: '7px',
    '&:hover': {
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    // [theme.breakpoints.up('sm')]: {
    //   width: '10.4rem',
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: '10.4rem',
    // },
    '&:disabled': {
      color: theme.palette.secondary.contrastText,
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.buttonInactiveColor,
    },
  },
  checkOffersButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoText1: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  infoText2: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  infoText3: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  infoText4: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  infoCTA: {
    backgroundColor: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,

    height: '2.5rem',

    '&:hover': {
      backgroundColor: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.secondary.contrastText,
    },
    [theme.breakpoints.up('xs')]: {
      width: '6rem',
      height: '2.5rem',
    },
    [theme.breakpoints.up('sm')]: {
      width: '6.8rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '6.5rem',
    },
    '&:disabled': {
      color: theme.palette.primary.contrastText,
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.buttonInactiveColor,
    },
  },
  infoCTASelected: {
    background: theme.palette.primary.buttonColor,
    border: `3px solid ${theme.palette.primary.buttonColor}`,
    color: theme.palette.secondary.contrastText,
    '&:hover': {
      border: `3px solid ${theme.palette.primary.buttonPrimaryHoverColor}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
  },
  addonMobileCtaCheck: {
    fontSize: '1.05rem',
    color: theme.palette.secondary.contrastText,
    marginLeft: '0.406rem',
  },
  infoCTA2: {
    color: theme.palette.primary.buttonColor,
    border: `0.1875rem solid ${theme.palette.primary.buttonColor}`,
    borderWidth: '0.2rem',
    height: '2.5rem',

    '&:hover': {
      backgroundColor: theme.palette.primary.buttonColor,
      color: theme.palette.secondary.contrastText,
      borderColor: theme.palette.primary.buttonColor,
    },
    [theme.breakpoints.up('xs')]: {
      width: '7rem',
      borderWidth: '0.1rem',
      height: '2.5rem',
    },
    [theme.breakpoints.up('sm')]: {
      width: '6.8rem',
      borderWidth: '0.15rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '7.5rem',
    },
    '&:disabled': {
      color: theme.palette.primary.buttonInactiveColor,
      boxShadow: 'none',
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
  infoCardDivider: {
    borderWidth: '0.5px',
    height: '3rem',
    borderColor: theme.palette.primary.disableCTA,
  },
  contractTagContainer: {
    // background:
    //   'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 51, 128, 0.01)',
    backgroundFilter: 'blur(10px)',
    marginBottom: '-0.4rem',
    paddingBottom: '0.4rem',
    borderRadius: '10px 10px 0 0',
  },
  checkOffersButtonNew: {
    backgroundColor: theme.palette.secondary.errorCTA,
    color: theme.palette.secondary.contrastText,
    // fontFamily: 'eir-bold',
    // fontSize: '1rem',
    // lineHeight: '1.5rem',
    // borderRadius: '2rem',
    height: '2.5rem',
    // textTransform: 'none',
    marginLeft: '42px',
    [theme.breakpoints.up('xs')]: {
      width: '18rem',
      marginLeft: '39px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '10.4rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '10.4rem',
    },
    '&:hover': {
      background: theme.palette.primary.hoverCTA,
      color: theme.palette.primary.contrastText,
    },

    '&:disabled': {
      color: theme.palette.secondary.radioText,
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.header,
    },
  },
  visibilityIcon: {
    marginLeft: '12px',
  },
  descriptionNew: {
    color: theme.palette.secondary.mobileActiveToggleBackground,
    fontStyle: 'normal',
    textAlign: 'center',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    marginBottom: '31px',
  },
});

export default styles;
